import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@weezevent/nacre';
import styles from './colorDots.module.css';

/**
 *
 * Component that renders up to `maxDots` colored dots,
 * and shows a "+N" dot when there are more items than displayed.
 *
 * Props:
 * - items: array of objects with { id, name, color }
 * - maxDots: maximum number of dots to display before collapsing the rest into "+N"
 */
export default function ColorDots({ items = [], maxDots = 4 }) {
    if (!items || items.length === 0) return null;

    const visibleItems = items.slice(0, maxDots);
    const hiddenItems = items.slice(maxDots);
    const hiddenCount = hiddenItems.length;

    return (
        <div className={styles.container}>
            {visibleItems.map((item, idx) => {
                const dotColor = item.color || '#cccccc';
                const label = item.name || item.id || '';
                return (
                    <Tooltip key={`${item.id}-${idx}`} triggerOnHover={true} title={label}>
                        <div
                            className={styles.dot}
                            style={{
                                backgroundColor: dotColor,
                                zIndex: 100 + idx
                            }}
                        />
                    </Tooltip>
                );
            })}

            {hiddenCount > 0 && (
                <Tooltip triggerOnHover={true} title={hiddenItems.map(item => item.name || item.id).join(', ')}>
                    <div className={`${styles.dot} ${styles.extra}`} style={{ zIndex: 100 + visibleItems.length }}>
                        +{hiddenCount}
                    </div>
                </Tooltip>
            )}
        </div>
    );
}

ColorDots.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string,
            color: PropTypes.string
        })
    ),
    maxDots: PropTypes.number
};

ColorDots.defaultProps = {
    items: [],
    maxDots: 4
};
